/* Collab editorial pages: reveal-on-scroll, hero intro, draggable lookbook,
   seamless marquee. Self-contained; safe to run more than once. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- reveal */

  var revealObserver = null;

  function getRevealObserver() {
    if (revealObserver || !('IntersectionObserver' in window)) return revealObserver;
    revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );
    return revealObserver;
  }

  function initReveals(scope) {
    var items = scope.querySelectorAll('.collab-reveal, .collab-hero');
    var observer = getRevealObserver();

    items.forEach(function (item) {
      if (item.dataset.collabRevealBound) return;
      item.dataset.collabRevealBound = '1';

      if (reduceMotion || !observer) {
        item.classList.add('is-in');
        return;
      }
      observer.observe(item);
    });
  }

  /* ------------------------------------------------------------- lookbook */

  function initLookbook(scope) {
    scope.querySelectorAll('.collab-lookbook__strip').forEach(function (strip) {
      if (strip.dataset.collabStripBound) return;
      strip.dataset.collabStripBound = '1';

      var progress = null;
      var wrapper = strip.closest('.collab-lookbook');
      if (wrapper) progress = wrapper.querySelector('.collab-lookbook__progress-bar');

      function updateProgress() {
        if (!progress) return;
        var scrollable = strip.scrollWidth - strip.clientWidth;
        var visible = strip.clientWidth / strip.scrollWidth;
        var ratio = scrollable > 0 ? strip.scrollLeft / scrollable : 0;
        var width = Math.max(visible * 100, 8);
        progress.style.width = width + '%';
        progress.style.transform = 'translateX(' + ratio * (100 / width) * (100 - width) + '%)';
      }

      strip.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();

      /* Pointer drag — mouse only; touch scrolls natively. */
      var dragging = false;
      var startX = 0;
      var startScroll = 0;
      var moved = 0;

      strip.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        moved = 0;
        startX = event.clientX;
        startScroll = strip.scrollLeft;
        strip.classList.add('is-dragging');
      });

      strip.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        var delta = event.clientX - startX;
        moved = Math.abs(delta);
        if (moved > 3 && strip.hasPointerCapture && !strip.hasPointerCapture(event.pointerId)) {
          strip.setPointerCapture(event.pointerId);
        }
        strip.scrollLeft = startScroll - delta;
      });

      function endDrag(event) {
        if (!dragging) return;
        dragging = false;
        strip.classList.remove('is-dragging');
        if (event && strip.releasePointerCapture && strip.hasPointerCapture(event.pointerId)) {
          strip.releasePointerCapture(event.pointerId);
        }
      }

      strip.addEventListener('pointerup', endDrag);
      strip.addEventListener('pointercancel', endDrag);
      strip.addEventListener('pointerleave', endDrag);

      /* Suppress the click that ends a drag. */
      strip.addEventListener(
        'click',
        function (event) {
          if (moved > 6) {
            event.preventDefault();
            event.stopPropagation();
          }
          moved = 0;
        },
        true
      );
    });
  }

  /* -------------------------------------------------------------- marquee */

  /* The track holds one authored group; duplicate it so the -50% keyframe
     loops seamlessly. */
  function initMarquee(scope) {
    scope.querySelectorAll('.collab-marquee__track').forEach(function (track) {
      if (track.dataset.collabMarqueeBound) return;
      track.dataset.collabMarqueeBound = '1';

      var group = track.querySelector('.collab-marquee__group');
      if (!group) return;

      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
  }

  /* ----------------------------------------------------------------- boot */

  function init(scope) {
    var root = scope || document;
    initReveals(root);
    initLookbook(root);
    initMarquee(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Theme editor: re-init sections as they are added or reloaded. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  window.CollabEditorial = { init: init };
})();
